import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

//component
import IcCreateNew from '../../../../../../../assets/images/IcCreateNew';
import Button from '../../../../../../Control/Button';
import DropdownControl from '../../../../../../Control/DropdownControl';
import FilterControl from '../../../../../../Control/FilterControl';
import Portal from '../../../../../../Control/Portal';
import CreateNewAdvertisement from './CreateNewAdvertisement';
import IcArrowDownGray from '../../../../../../../assets/images/IcArrowDownGray';
import DatePickerItem from '../../../../BreadcrumbAndTool/FilterTransaction/DatePickerItem';
import { WrapDateRange } from '../../../../BreadcrumbAndTool/FilterTransaction/index.styles';

//styles
import { InputFilter } from '../../../../../../Control/FilterControl/index.styles';
import { WrapToolAdvertisement } from './index.styles'
import { useEffect } from 'react';
import { useRef } from 'react';
import { GET_LIST_ADVERTISEMENT_MERCHANT } from '../../../../../../../redux/merchant/detailsMerchant/advertisement/types';
import { getListAdvertisementMerchant, getListAdvertisementSearchByInterval, getListAdvertisementSearchByName, resetListAdvertisementMerchant } from '../../../../../../../redux/merchant/detailsMerchant/advertisement/action';
import { formatTimeEndDate } from '../../../../../../../helper/formatTimeEndDate';

const KEY_ADVERTISEMENT_NAME = "1"
const KEY_TIME_SELECTION = "2"

const listFilterAdvertisementTypes = [
    {
        key: KEY_ADVERTISEMENT_NAME,
        text: 'Tên file'
    },
    {
        key: KEY_TIME_SELECTION,
        text: 'Ngày tạo'
    },
]

const filterSize = 20

const SelectDateRange = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}) => {
    return <WrapDateRange>
        <DatePickerItem
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            textEmpty="Từ ngày"
            showTimeSelect={false}
            dateFormat="dd/MM/yy"
        />
        <IcArrowDownGray className="arrow-right" />
        <DatePickerItem
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            textEmpty="Đến ngày"
            showTimeSelect={false}
            dateFormat="dd/MM/yy"
        />
    </WrapDateRange>
}

const ToolAdvertisement = () => {
    const { merchantId } = useParams();
    const dispatch = useDispatch()
    const inputSearchRef = useRef(null)
    
    const [filterCond, setFilterCond] = useState(listFilterAdvertisementTypes[0]);
    const [isShowModalCreateAdvertisement, setIsShowModalCreateAdvertisement] = useState(false)
    const [idSearch, setIdSearch] = useState("")
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const { total, list, type } = useSelector(state => ({
        total: state.merchantReducer.detailsMerchantReducer.advertisement.total,
        list: state.merchantReducer.detailsMerchantReducer.advertisement.list,
        type: state.merchantReducer.detailsMerchantReducer.advertisement.type,
    }))

    useEffect(() => {
        setIdSearch("")
        setStartDate(null)
        setEndDate(null)
        if (inputSearchRef.current) inputSearchRef.current.value = ''
    }, [JSON.stringify(filterCond)]);

    
    useEffect(() => {
        // const types = list.type
        const { key } = filterCond
        if ( key !== KEY_ADVERTISEMENT_NAME && type === GET_LIST_ADVERTISEMENT_MERCHANT ) {
            setIdSearch("")
            setStartDate(null)
            setEndDate(null)
            if (inputSearchRef.current) inputSearchRef.current.value = ''
        }
        if ( key !== KEY_ADVERTISEMENT_NAME && type === GET_LIST_ADVERTISEMENT_MERCHANT && startDate && endDate ) {
            setIdSearch("")
            setStartDate(null)
            setEndDate(null)
            setFilterCond(listFilterAdvertisementTypes[0])
            if (inputSearchRef.current) inputSearchRef.current.value = ''
        }
        if ( key === KEY_ADVERTISEMENT_NAME && type === GET_LIST_ADVERTISEMENT_MERCHANT) {
            setIdSearch("")
            setStartDate(null)
            setEndDate(null)
            setFilterCond(listFilterAdvertisementTypes[0])
            if (inputSearchRef.current) inputSearchRef.current.value = ''
        }
    }, [JSON.stringify(list), JSON.stringify(filterCond), type]);


    const _handleSearch = () => {
        const { key } = filterCond
        if(!idSearch && !startDate && !endDate){
            dispatch(resetListAdvertisementMerchant())
            dispatch(getListAdvertisementMerchant({
                merchantId,
                filterFrom: '',
                filterSkip: 0,
                filterSize,
            }))
        }
        switch (key) {
            case KEY_ADVERTISEMENT_NAME:
                if(!idSearch) break;
                dispatch(resetListAdvertisementMerchant())
                dispatch(getListAdvertisementSearchByName({
                    merchantId,
                    name: idSearch,
                    filterFrom: '',
                    filterSkip: 0,
                    filterSize,
                }))
                break;
            case KEY_TIME_SELECTION:
                if(!startDate || !endDate) break;
                dispatch(resetListAdvertisementMerchant())
                dispatch(getListAdvertisementSearchByInterval({
                    merchantId,
                    startTime: startDate,
                    closeTime: formatTimeEndDate(endDate),
                    filterFrom: '',
                    filterSkip: 0,
                    filterSize,
                }))
                break;
            default:
                break;
        }
    }

    const dropdownFilter = useMemo(() => {
        return (
            <DropdownControl 
                dataSelection={listFilterAdvertisementTypes}
                valueSelected={filterCond} 
                handleSetValueSelect={val => setFilterCond(val)}
            />
        )
    }, [filterCond])

    const filterComponent = useMemo(() => {
        const { key, text } = filterCond
        if(key === KEY_TIME_SELECTION)
            return <SelectDateRange
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
        />
        return (
            <InputFilter 
                type="text"
                ref={inputSearchRef}
                placeholder={`Nhập ${text}`}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        _handleSearch()
                    }
                }}
                onChange={e => setIdSearch(e.target.value)}
            />
        )
    }, [startDate, endDate, JSON.stringify(filterCond), _handleSearch])

    const _handleClickBtnCreate = () =>{
        setIsShowModalCreateAdvertisement(pre => !pre)
    }

    return (
        <WrapToolAdvertisement>
            <div className="wrap-filter">
                <FilterControl 
                    dropdownFilter={dropdownFilter}
                    filterComponent={filterComponent}
                    handleSearch={_handleSearch}
                />
            </div>
            <div className="total-of-data">
                <span>Quảng cáo:</span>
                <span>{total}</span>
            </div>
            <div>
                <Button 
                    iconBtn={<IcCreateNew />}
                    text="Thêm mới"
                    onClick={_handleClickBtnCreate}
                />
            </div>
            {
                isShowModalCreateAdvertisement &&
                <Portal>
                    <CreateNewAdvertisement 
                        onClickIconClose={_handleClickBtnCreate} 
                        setIsShowModalCreateAdvertisement={setIsShowModalCreateAdvertisement}
                    />
                </Portal>
            }
        </WrapToolAdvertisement>
    )
}

export default ToolAdvertisement
